import styled from 'styled-components';

export const StyledHeader = styled.header`
  background-color: #6c5f5b;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 1.2rem 2rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 0.1rem solid rgba(255, 255, 255, 0.2);
  button {
    color: #fff;
  }
`;
